import { computed, makeObservable } from 'mobx';

import { RoleApiClient } from '../api/role-api-client';
import { IRole, IUpdateRolePermissionsParams } from '../dto/access-management/user-role-dto';
import { AccountType } from '../dto/access-management/account-dto';

import { AssureBaseStore, IAssureStoreConstructorOptions } from './assure-base.store';
import { getErrorMessage } from 'common-utils';

export class RoleStore extends AssureBaseStore<RoleApiClient, IRole> {

    public constructor(options: IAssureStoreConstructorOptions) {
        super(options);
        makeObservable(this);
    }

    protected get apiClient(): RoleApiClient {
        return this.apiClientStore.apiClients.role;
    }

    public async getManagedRoles(force?: boolean): Promise<IRole[]> {
        this.setDataLoading(true);
        this.setError(undefined);
        try {
            if (!force && this.hasEntities()) return this.entities;
            const roles = await this.apiClient.getManagedRoles();
            this.setEntities(roles);
            return roles;
        } catch (err) {
            this.setError(getErrorMessage(err));
        } finally {
            this.setDataLoading(false);
        }
    }

    public async getAvailableRoles(accountId: number, accountType?: AccountType): Promise<IRole[]> {
        const result = await this.apiClient.getAvailableRoles(accountId, accountType);
        return result.roles;
    }

    public grantPermissionsToRole(params: IUpdateRolePermissionsParams[]): Promise<IRole[]> {
        return this.apiClient.grantPermissionsToRole(params);
    }

    @computed
    public get managedRoles(): IRole[] {
        return this.entities;
    }
}
